// extracted by mini-css-extract-plugin
export var colorSquare = "_pp-0";
export var danger = "_pp-5";
export var lightPink = "_pp-8";
export var neutralBlue = "_pp-7";
export var neutralYellow = "_pp-6";
export var normal = "_pp-1";
export var primary = "_pp-2";
export var primaryLight = "_pp-3";
export var solidBlack = "_pp-g";
export var solidGreen = "_pp-b";
export var solidLightBlue = "_pp-d";
export var solidNavy = "_pp-c";
export var solidOrange = "_pp-f";
export var solidPink = "_pp-e";
export var solidRed = "_pp-9";
export var solidYellow = "_pp-a";
export var success = "_pp-4";